import TableList from "@components/templates/tablelist";
import { HttpGetValuationList, HttpActiveValuation, } from "@/service/tasks";
import { mapGetters } from "vuex";
import compDetail from './update';
export default {
    mixins: [TableList],
    components:{
        compDetail
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            Searchs: {
                show: true,
                labelWidth: 90
            },
            Plugins: { show: true }
        };
    },

    methods: {
        ajaxRequest: HttpGetValuationList,
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(",")) + "";
                if (!params.length)
                    return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {
                case "add":
                    this.$router.push({
                        name: "tasksValuationUpdate",
                        params: { type: "add" },
                    });
                    break;
                case "edit":
                    this.$router.push({
                        name: "tasksValuationUpdate",
                        params: { type: "edit" },
                        query: { id: params }
                    });
                    break;
                case "query":
                    this.operate = {
                        title: this.$t('global.common.query', { defaultValue: '查看' }),
                        show: true,
                        width: 1200,
                        component: "compDetail",
                        activeid: params,
                        querytype:'query',
                        showFooter: false
                    }
                    break;
                case "queryBlank":
                    var url=this.$router.resolve({
                        name: "tasksValuationUpdate",
                        params: { type: "query" },
                        query: { id: params},
                    });
                    window.open(url.href, '_blank');
                    break;
                case "active":
                    this.operate = {
                        show: true,
                        alert: "primary",
                        params: { id: params,status:1 },
                        title: this.$t('fbb.accountmanage.active', { defaultValue: '启用' }),
                        ajaxRequest: HttpActiveValuation
                    };
                    break;
                case "disable":
                    this.operate = {
                        show: true,
                        alert: "warning",
                        params: { id: params,status:0 },
                        title: this.$t('fbb.accountmanage.disable', { defaultValue: '禁用' }),
                        desc:'禁用方案后，关联的报价模板将一起禁用，是否确定禁用？',
                        ajaxRequest: HttpActiveValuation
                    };
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id, status } = row;
            return [
                {
                    label: this.$t('global.common.query', { defaultValue: '查看' }),
                    params: id,
                    show: true,
                    operate: "query"
                },
                {
                    label: this.$t('global.common.operation_edit', { defaultValue: '编辑' }),
                    params: id,
                    show: true,
                    operate: "edit"
                },
                {
                    label: this.$t('fbb.accountmanage.active', { defaultValue: '启用' }),
                    params: id,
                    show: status == 0,
                    operate: "active"
                },
                {
                    label: this.$t('fbb.accountmanage.disable', { defaultValue: '禁用' }),
                    params: id,
                    show: status == 1,
                    operate: "disable"
                }
            ];
        }
    },
    computed: {
        ...mapGetters('dictionary', ['getCusBillTypeList']),
        ToolsData() {
            return [
                {
                    name: this.$t('erp.product.new_add', { defaultValue: '添加' }),
                    operate: "add",
                    theme: "primary"
                },
            ];
        },
        SearchsData() {
            return [
                // {
                //     label: '费用类型',
                //     tag: 'div',
                //     show:true,
                //     children:(h)=>{
                //         return h("compMultipleSelect",{
                //             props: {
                //                 options:this.getCusBillTypeList,
                //                 modelValue:this.formData.search.IN_carrier,
                //                 placeholder:'承运商',
                //                 // isShowCheckAll:false,//是否展示全选按钮
                //             },
                //             on:{
                //                 'update:modelValue':(val)=>{
                //                     this.formData.search.IN_carrier = val
                //                 }
                //             }
                //         })
                //     }
                // },
                {
                    label: '方案代码',
                    tag: "Input",
                    key: "EQ_code",
                    show: true,
                },
                {
                    label: this.$t('global.common.status', { defaultValue: '状态' }),
                    tag: "Select",
                    key: "EQ_status",
                    show: true,
                    options: [
                        {value:0,label:'禁用'},
                        {value:1,label:'启用'},
                    ]
                }
            ];
        },
        columns() {
            return [
                {
                    title: this.$t('global.common.actions', { defaultValue: '操作' }),
                    maxWidth: 90,
                    render: this.getOperateNodes
                },
                {
                    title: '方案代码',
                    key: "code",
                    sortable: true,
                    render:(h,{row})=>{
                        return <div>
                            <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.code}</a>
                            <a onClick={this.handleOperates.bind(this, row.id, 'queryBlank')}><vIcon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                        </div>
                    }
                },
                {
                    title: '方案名称',
                    key: "name"
                },
                {
                    title: '描述',
                    key: "description"
                },
                {
                    title: this.$t('global.common.status', { defaultValue: '状态' }),
                    key: "status",
                    width:100,
                    render:(h,{row})=>{
                        return <div>
                            <Tag type="border" v-show={row.status === 1} color="success">启用</Tag>
                            <Tag type="border" v-show={row.status !== 1} color="default">禁用</Tag>
                        </div>
                    }
                },
                {
                    title: this.$t('fbb.bill.freeze_createdat', { defaultValue: '创建日期' }),
                    key: "createdAt"
                }
            ];
        }
    }
};
